import React, { useState } from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import { Grid } from "@material-ui/core";
import "./textAreaHL.css";

const TextAreaHLPure = (props) => {
  const {
    labelTextArea, //Label text from input
    valueTextData, //If it has a predefined value or a start value
    characterLimit,
    required,
    handleChangeTextArea, //Function onChange to changes value
    errorInput, //Error true or false
    errorTextArea, //Error text to validate TextArea
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    rowsTextArea, //Rows to text Area, default value is 5, string
    informationIcon, // Choose the information icon true or false to custom img
  } = props;

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  // const [textAreaValue, setTextAreaValue] = useState(valueTextData || "");
  // const [errorInput, setErrorInput] = useState(false);

  // const handleChange = (event) => {
  //   if (event.target.value === undefined || event.target.value === "") {
  //     setErrorInput(true);
  //   } else {
  //     setTextAreaValue(event.target.value);
  //   }
  // };

  const [chars, setChars] = useState(0);

  const onLimitedTextChange = (event) => {
    setChars(event.target.value.length);
    handleChangeTextArea(event);
  }

  return (
    <div
      item
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className={"textAreaHLPure-container"}
    >
      <Grid item className={"textAreaHLPure-container-textFlex"}>
        <label className="textAreaHLPure-label" name="label">
          {labelTextArea} {required ? "*" : ""}
        </label>
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </Grid>
      <textarea
        {...props}
        rows={rowsTextArea}
        className="textAreaHLPure-input"
        id="valueTextData"
        name="valueTextData"
        value={valueTextData || ""}
        onChange={characterLimit ? onLimitedTextChange : handleChangeTextArea}
        component={props.validateInput}
        maxLength={characterLimit}
      />
      <div className="inputHLPure-hints">
        {errorInput && (
          <span className="hint-message-error">{errorTextArea}</span>
        )}
        {characterLimit && (
          <span className="character-limit">{chars}/{characterLimit}</span>
        )}
      </div>
    </div>
  );
};

export { TextAreaHLPure as default };
